import styled from 'styled-components'
import { Search } from 'semantic-ui-react'
import { VariableSizeList as List } from 'react-window'

// styled(Segment) breaks when importing from the index file for some reason
import Segment from '../Segment'

interface StyledListProps {
  disabled?: boolean
}

export const StyledList = styled(List)<StyledListProps>`
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  pointer-events: ${props => (props.disabled ? 'none' : 'initial')};
`

export const FluidSearch = styled(Search)`
  &&& {
    width: 100%;
    margin-bottom: 1em;
    padding: 0 0.5em;

    .input {
      width: 100%;
    }
  }
`

export const Title = styled.div`
  margin: 0.5em;
  color: #797979;
`

export const NoResults = styled.div`
  padding: 0 1em;
  font-style: italic;
`

export const StyledSegment = styled(Segment)`
  &&& {
    position: relative;
    width: 250px;
    min-height: 350px;
    margin: -0.25em -1em !important;
    z-index: 5;

    :before {
      background: rgba(255, 255, 255, 0.1);
    }

    :after {
      display: none !important;
    }
  }
`
